import { Col } from "antd";
import { FileText } from "lucide-react";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";
import Subtitle from "../../Subtitle";

export default function NotasSection(props) {
  const { verification, setVerification, hidden, loading } = props;

  return (
    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
      <Subtitle title="Notas" marginTop={16} />
      <DataGroup
        title={"Notas"}
        formName={"Notas"}
        mainData={verification}
        setMainData={setVerification}
        verification={verification}
      >
        <DataItem
          icon={<FileText size={16} />}
          iconColor="#1890ff"
          keyName="Notas internas"
          value={verification?.Notas}
          valueType="text"
          fieldWidth={4}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<FileText size={16} />}
          iconColor="#1890ff"
          keyName="Nota Sediver"
          value={verification?.NotaSediver}
          valueType="text"
          fieldWidth={4}
          hidden={hidden}
          loading={loading}
        />
      </DataGroup>
    </Col>
  );
}
